<template>
    <div>
        <v-layout
                wrap
        >
            <v-navigation-drawer
                    v-model="drawer"
                    style="font-family: Roboto, sans-serif"
                    width="350"
                    fixed
                    right
                    temporary
                    disable-resize-watcher
                    class="pt-4"
            >

                <div class="text-center pa-1 mt-0 fixed-header">

                    <h1 class="title font-weight-light">
                        {{ getLabel('commons.client.plural') }} del día
                    </h1>

                    <dialog-date-picker
                        calendar
                        width="70%"
                        :value="date"
                        class="mt-2"
                        @change="onDateChange"
                        ref="datePicker" />

                    <v-layout wrap>
                        <v-flex xs12 pa-0 mt-2>
                            <v-sheet height="3px">
                                <v-progress-linear height="2" indeterminate v-if="loading"/>
                            </v-sheet>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap>
                        <v-flex xs12 mt-1>
                            <div v-if="!loading && events.length > 0">
                                <v-btn
                                        rounded
                                        small
                                        depressed
                                        @click="unattendedOnly=true"
                                        :color="unattendedOnly ? 'primary' : 'default'">En espera ({{events.filter(evt => evt.event_status.id === 3).length}})</v-btn>

                                <v-btn
                                        rounded
                                        small
                                        depressed
                                        class="ml-1"
                                        @click="unattendedOnly=false"
                                        :color="!unattendedOnly ? 'primary' : 'default'">Todos ({{events.length}})</v-btn>

                            </div>
                        </v-flex>
                    </v-layout>
                </div>

               <div class="list-container">
                   <v-slide-y-transition>
                       <template v-if="!loading">
                           <div  class="mt-6">

                               <v-list two-line >

                                   <div v-if="items.length === 0" class="caption mx-auto text-center mt-3">
                                       No hay {{getLabel('commons.client.plural').toLowerCase() }} en esta lista
                                   </div>

                                   <template v-for="(event, index) in items">
                                       <v-divider :key="`div-${index}`" />
                                       <attention-event-list-item
                                               @click:appointment="onAppointmentClick(event)"
                                               :key="index"
                                               :event="event" />
                                   </template>

                               </v-list>
                           </div>
                       </template>
                   </v-slide-y-transition>
               </div>


            </v-navigation-drawer>
            <v-snackbar
                    style="font-family: Roboto, sans-serif"
                    v-model="snackBar"
                    :color="snackBarColor"
                    top
                    :timeout="7000"
                    @click="snackBarClick"
            >
                {{ snackBarText }}
                <v-btn
                        color="white"
                        text
                        @click="snackBar = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
        </v-layout>
    </div>

</template>

<script>

    import AttentionEventListItem from '@/components/appointments/AttentionEventListItem'
    import {mapMutations} from 'vuex'

    import DialogDatePicker from '@/components/common/DialogDatePicker'
    import AppointmentsMixin from "@/mixins/AppointmentsMixin";
    import AttentionClientListMixin from "@/mixins/AttentionClientListMixin";

    export default{
        components: {
            AttentionEventListItem,
            DialogDatePicker
        },
        mixins: [AppointmentsMixin, AttentionClientListMixin],
        props: {
            specialistId: {
                type: Number
            },
            individualProvider: {
                type: Boolean,
                default: false
            }
        },

        beforeDestroy(){
          var vm = this
          vm.setEvent(null)
          if(vm.schedule){
            vm.leaveSockets()
          }
        },

        data(vm){
            return {
              snackBarClickDefaultAction: vm.showClientList
            }
        },

        methods: {
            ...mapMutations(['showClientList', 'hideClientList']),

            showDatePicker(){
                this.$refs.datePicker.show()
            },

        },
        computed: {
            drawer: {
                get(){
                    return this.clientListIsVisible
                },
                set(val){
                    val ? this.showClientList() : this.hideClientList()
                }
            },
        },

    }

</script>

<style scoped>

    .fixed-header{
        position: fixed !important;
        text-align: center;
        z-index: 100;
        width: 100%;
    }

    .list-container{
        margin-top: 100px;
        height: calc(100% - 100px);
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>
